import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import RearrangePDFPagesImagesListScreen from "./RearrangePDFPagesImagesListScreen";
import { BASE_URL } from "../Config";

function RearrangePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Rearrange PDF Pages Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/rearrange_pdf", title: "Organize PDF Files Online" },
    data2: { link: "/rearrange_pdf", title: "Rearrange PDF Pages Online" },
    data3: { link: "/rearrange_pdf", title: "Change PDF Pages Order" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Rearrange PDF pages online easily. Reorder, move, and organize PDF pages quickly with our fast, secure, and simple PDF rearrange tool."
      ></meta>
      <meta
        name="keywords"
        content="rearrange pdf, reorder pdf pages, organize pdf pages, pdf page organizer, move pdf pages, rearrange pdf online, pdf editor online, reorder pdf online, pdf management tool, sort pdf pages, change pdf page order, pdf page editor, rearrange pdf files, organize pdf online, pdf document organizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <RearrangePDFPagesImagesListScreen
          title={title}
        ></RearrangePDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Rearrange PDF Pages website offers a fast, secure, and flexible solution to organize and reorder PDF documents both offline and online. Designed for students, professionals, and businesses, this powerful tool allows you to rearrange PDF pages, move, swap, rotate, and reorder pages with complete control while preserving the original document quality. With offline functionality, all processing happens directly on your device, ensuring maximum privacy and data security without uploading files to external servers. When internet access is available, users can easily rearrange PDF pages online through a smooth, browser-based interface for instant results. Whether you need to organise PDF pages, merge content logically, or change PDF pages order for reports, contracts, assignments, or presentations, this tool delivers accurate and professional output. The platform also supports organise PDF pages online, making it convenient to manage documents from any device. Using advanced page-handling technology, the tool maintains original formatting, text clarity, and image quality while rearranging pages. Compatible with desktop and mobile devices, this website helps users organize PDFs efficiently, improve document readability, and streamline workflows. If you are searching for the best tool to rearrange PDF pages, rearrange PDF pages online, organise PDF pages, organise PDF pages online, reorder pdf pages or change PDF pages order securely and quickly, this platform provides a complete, user-friendly PDF management solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Arrange",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Rearrange PDF Pages Tool"
            why_use={[
              {
                title: "Organize PDF Pages in the Correct Order",
                description:
                  "PDF files created from multiple sources often have incorrect page order. Our rearrange PDF pages tool helps organize content logically and professionally.",
              },
              {
                title: "Change PDF Pages Order Easily",
                description:
                  "Instead of recreating documents, you can quickly change PDF pages order using a simple and efficient rearrange PDF pages feature.",
              },
              {
                title: "Improve Document Readability",
                description:
                  "Proper page sequence improves document flow and clarity. Tools to organise PDF pages online help create easy-to-read and well-structured PDFs.",
              },
              {
                title: "Rearrange PDF Pages Online Anytime",
                description:
                  "With rearrange PDF pages online, users can manage and reorder PDF files from any device without installing heavy software.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "Our offline tool allows you to rearrange PDF pages securely without uploading files, ensuring complete data privacy.",
              },
              {
                title: "Create Professional-Looking Documents",
                description:
                  "Well-organized PDFs look more professional. Using tools to organise PDF pages helps prepare reports, contracts, and presentations.",
              },
              {
                title: "Simplify Editing and Collaboration",
                description:
                  "Reordering pages makes collaboration easier. Rearrange PDF pages online tools help teams review and finalize documents faster.",
              },
              {
                title: "Fix Scanning and Merging Errors",
                description:
                  "Scanned or merged PDFs often have mixed-up pages. A change PDF pages order tool quickly corrects these issues.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Instead of manually editing content, you can organise PDF pages online in seconds, improving productivity.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default RearrangePDFMain;
